module.exports = __webpack_public_path__ + "img/exh-reg.be510fa9.png";